var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadgeGuarantee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "workspace_premium_black_24dp",
    transform: "translate(0.075 0.075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5251",
    width: 84,
    height: 84,
    transform: "translate(-0.075 -0.075)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13028",
    d: "M23.844,42.842l8.105-6.149,8.07,6.149-3.074-9.957,8.105-6.428H35.129L31.95,16.639,28.77,26.456H18.848l8.07,6.428ZM59.9,29.95A27.95,27.95,0,1,0,10.987,48.4V75.368L31.95,68.381l20.962,6.987V48.4A27.812,27.812,0,0,0,59.9,29.95ZM31.95,8.987A20.962,20.962,0,1,1,10.987,29.95,20.979,20.979,0,0,1,31.95,8.987Zm0,52.406L17.975,64.957V54.126a27.766,27.766,0,0,0,27.95,0V64.957Z",
    transform: "translate(9.975 4.987)",
    fill: "#71d099"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGuarantee);
export default __webpack_public_path__ + "static/media/badge-guarantee.ec728da182983b71cbe220ccc04aca6f.svg";
export { ForwardRef as ReactComponent };